export class CreateAbsenceCommand {
  repo
  screen_data

  constructor(repo, screen_data) {
    this.repo = repo;
    this.screen_data = screen_data;
  }

  _parseError(error) {
    // Parsear el error del backend
    let errorMsg = "Error al guardar la ausencia";
    let errorDetails = "";

    // Si el error es directamente un Error de JavaScript con mensaje
    if (error && error.message) {
      errorMsg = error.message;
    }

    // Si viene del response HTTP
    if (error && error.response && error.response.data) {
      const responseData = error.response.data;

      // Si hay un mensaje específico del backend
      if (responseData.error) {
        errorMsg = responseData.error;
      } else if (responseData.output && responseData.output.error) {
        errorMsg = responseData.output.error;
      } else if (responseData.message) {
        errorMsg = responseData.message;
      } else if (typeof responseData === 'string') {
        errorMsg = responseData;
      }
    }

    // Extraer el mensaje de ValueError o Exception del backend
    // El formato típico es "ValueError: mensaje" o "Exception: mensaje"
    const valueErrorMatch = errorMsg.match(/ValueError:\s*(.+?)(?:\n|$)/);
    const exceptionMatch = errorMsg.match(/\w+Error:\s*(.+?)(?:\n|$)/);

    if (valueErrorMatch && valueErrorMatch[1]) {
      errorMsg = valueErrorMatch[1].trim();
    } else if (exceptionMatch && exceptionMatch[1]) {
      errorMsg = exceptionMatch[1].trim();
    }

    // Traducir errores comunes del backend a mensajes más amigables y específicos
    if (errorMsg.includes("reason no puede estar vacío") || errorMsg.toLowerCase().includes("reason") || errorMsg.toLowerCase().includes("motivo")) {
      errorMsg = "Falta el campo motivo";
      errorDetails = "Por favor, escribe una justificación para tu ausencia antes de continuar.";
    } else if (errorMsg.includes("La fecha de inicio debe ser anterior") || errorMsg.includes("start >= end")) {
      errorMsg = "Fechas seleccionadas incorrectas";
      errorDetails = "La hora de inicio debe ser anterior a la hora de fin. Por favor, verifica los horarios seleccionados.";
    } else if (errorMsg.includes("Ya existe una ausencia")) {
      // Extraer las fechas del mensaje si están presentes
      const existingMatch = errorMsg.match(/Existente:\s*(.+?)\s*a\s*(.+)/);
      errorMsg = "Conflicto con otra ausencia";
      if (existingMatch) {
        errorDetails = `Ya tienes una ausencia registrada que se solapa con este horario (${existingMatch[1]} a ${existingMatch[2]}). Por favor, selecciona otro rango de fechas.`;
      } else {
        errorDetails = "Ya existe una ausencia registrada en este rango de fechas. Por favor, verifica tu calendario y selecciona otro horario.";
      }
    } else if (errorMsg.includes("Formato de fecha inválido")) {
      errorMsg = "Formato de fecha inválido";
      errorDetails = "El formato de las fechas no es válido. Por favor, asegúrate de usar el formato correcto (DD/MM/YYYY).";
    } else if (errorMsg.includes("uuid no puede estar vacío")) {
      errorMsg = "Error interno";
      errorDetails = "Ha ocurrido un error interno. Por favor, intenta de nuevo.";
    } else if (errorMsg.includes("Ha habido un error en el proceso")) {
      errorMsg = "Error al procesar la solicitud";
      errorDetails = "No se pudo guardar la ausencia. Por favor, verifica todos los campos e intenta de nuevo.";
    } else {
      // Para otros errores no manejados específicamente
      errorDetails = "Por favor, verifica que todos los campos estén completos y correctos.";
    }

    return {
      message: errorMsg,
      details: errorDetails
    };
  }

  async openCreatePopup(selectedDate) {
    const popup = this.screen_data.create_absence_popup;

    const date = selectedDate ? new Date(selectedDate) : new Date();

    const absence = await popup.showWithDate(date, {
      start: date,
      end: date,
      reason: "",
    });

    if (!absence) return;

    if (!absence.reason || absence.reason.trim() === "") {
      popup.errors.reason = "El campo motivo es obligatorio";
      return;
    }

    this.screen_data.ui_loading = true;

    try {
      // Habilitar notificación por email a admins
      absence.sendEmailNotification = true;

      await this.repo.save(absence);

      this.screen_data.absences = await this.repo.find_all();
      popup.close(absence);

      // Mostrar mensaje de éxito
      if (this.screen_data.showSnackbar) {
        this.screen_data.showSnackbar('success', 'Ausencia creada correctamente');
      }
    } catch (error) {
      const errorInfo = this._parseError(error);

      // Mostrar dialog de error si está disponible
      if (popup.showErrorDialog) {
        popup.showErrorDialog(errorInfo.message, errorInfo.details);
      } else if (this.screen_data.showSnackbar) {
        // Fallback al snackbar si no hay dialog
        this.screen_data.showSnackbar('error', errorInfo.message);
      }

      popup.errors = { general: errorInfo.message };

      // No cerrar el popup para que el usuario pueda corregir el error
      // popup.close() se omite intencionalmente aquí
    } finally {
      this.screen_data.ui_loading = false;
    }
  }

  async execute() {
    const popup = this.screen_data.create_absence_popup;

    const absence = await popup.show({
      start: new Date(),
      end: new Date(),
      reason: "",
    });

    if (!absence) return;

    if (!absence.reason || absence.reason.trim() === "") {
      popup.errors.reason = "El campo motivo es obligatorio";
      return;
    }

    this.screen_data.ui_loading = true;

    try {
      // Habilitar notificación por email a admins
      absence.sendEmailNotification = true;

      await this.repo.save(absence);

      this.screen_data.absences = await this.repo.find_all();
      popup.close(absence);

      // Mostrar mensaje de éxito
      if (this.screen_data.showSnackbar) {
        this.screen_data.showSnackbar('success', 'Ausencia creada correctamente');
      }
    } catch (error) {
      const errorInfo = this._parseError(error);

      // Mostrar dialog de error si está disponible
      if (popup.showErrorDialog) {
        popup.showErrorDialog(errorInfo.message, errorInfo.details);
      } else if (this.screen_data.showSnackbar) {
        // Fallback al snackbar si no hay dialog
        this.screen_data.showSnackbar('error', errorInfo.message);
      }

      popup.errors = { general: errorInfo.message };

      // No cerrar el popup para que el usuario pueda corregir el error
      // popup.close() se omite intencionalmente aquí
    } finally {
      this.screen_data.ui_loading = false;
    }
  }
}